// 예약취소
import { useState, useEffect } from "react";
import BottomMenu from "./BottomMenu";
import { Grid, Avatar, Box } from "@mui/material";
import { shadows } from "@mui/system";
import BottomButton from "./BottomButton";
import MypageLoggedOut from "./MypageLoggedOut";
import { loginState, configState } from "../lib/State";
import Loading from "./Loading";
import get_session from "../lib/get_session";
import pr from "../lib/pr";
import axios from "axios";
import get_token from "../lib/get_token";
// import MypageLoggedIn from "./MypageLoggedIn";
import Test3a from "./Test3a";

function Profile() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const token = get_token();

  const get_session = async () => {
    const cid = configState.cid;
    let result = await axios.post(configState.api + "/gympass/get_session", {
      token: token,
      cid: cid,
    });
    if (result.data.mcd !== "" && result.data.success === 1) {
      setLogin({ mcd: result.data.mcd, level: result.data.level });
    }
    setLoaded(true);
  };
  useEffect(() => {
    get_session();
  }, []);

  return (
    <>
      {loaded ? (
        <Grid container height="100vh" direction="column">
          {login.mcd === "" ? (
            <MypageLoggedOut />
          ) : (
            <Test3a login={login} />
          )}

          <BottomButton login={login} loaded={loaded} />
          <BottomMenu active="mypage"></BottomMenu>
        </Grid>
      ) : (
        <Loading />
      )}
    </>
  );
}

export default Profile;
